var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Grid", {
    attrs: {
      module: _vm.module,
      data: _vm.affiliateList,
      columns: _vm.columnOptions,
      onSelect: _vm.select,
      loading: _vm.loadingData,
      filterable: _vm.filterable
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }